import React                 from 'react';
import { Flex, Box, Center } from '@chakra-ui/react';
import Img                   from 'gatsby-image';
import { graphql }           from 'gatsby';

import Heading       from '@interness/web-core/src/components/text/Heading/Heading';
import HeaderMedia   from '@interness/theme-default/src/components/HeaderMedia';
import Wrapper       from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import { findMedia } from '@interness/web-core/src/components/_helpers';
import Spacer        from '@interness/web-core/src/components/structure/Spacer/Spacer';

import Subnavigation from '../components/Subnavigation';

const SonderpalettePage = (props) => {
  return (
    <>
      <HeaderMedia id="produkte"/>
      <Subnavigation title="Produkte" menu={[
        {
          'displayName': 'Fertigung',
          'path': '/fertigung'
        },
        {
          'displayName': 'Europaletten',
          'path': '/europaletten'
        },
        {
          'displayName': 'Paletten 1/2/3 weg',
          'path': '/paletten-123-weg'
        },
        {
          'displayName': 'Sonderpaletten',
          'path': '/sonderpaletten'
        },
        {
          'displayName': 'Chemiepaletten',
          'path': '/chemiepaletten'
        },
        {
          'displayName': 'Euro-Gitterboxen',
          'path': '/euro-gitterboxen'
        },
        {
          'displayName': 'Vermietung / Reparaturen',
          'path': '/vermietung-reparaturen'
        }
      ]}/>
      <Spacer/>
      <Wrapper>
        <Heading>Sonderpaletten</Heading>

        <Center textAlign='center'>
          Die langjährige Erfahrung in der Holzverarbeitung ist die Basis unserer Kompetenz : Entwicklung und
          Herstellung von Sonderpaletten. Gemeinsam mit unseren Kunden entwickeln wir das spezielle Anforderungsprofil.
          Unser Ziel: Hoher Kundennutzen bei optimalem Preis- Leistungsverhältnis.
        </Center>

        <Spacer/>

        <Flex flexWrap="wrap">
          <Box width={['100%', '100%', '40%', '40%']}>
            <h3>Einweg-Palette</h3>
            <p>
              Spezialpalette aus Holz für Tanks, individuelle Fertigung nach Kundenwunsch.
            </p>
            Abmessungen in mm
            <ul>
              <li>800 x 1000</li>
              <li>800 x 1200</li>
              <li>1000 x 1200</li>
            </ul>
          </Box>
          <Box width={['100%', '100%', '60%', '60%']} px={6}>
            <Center>
              <Img fixed={findMedia(props.data.collection.images, 'pg-sonder-1-palette').childImageSharp.fixed}/>
            </Center>
          </Box>
        </Flex>
      </Wrapper>
      <Spacer/>
    </>
  )
};

export default SonderpalettePage;


export const query = graphql`
    query {
        collection: directusMediaCollection(name: {eq: "sonderpaletten"}) {
            name
            images: media {
                file {
                    localFile {
                        name
                        childImageSharp {
                            fixed {
                                ...GatsbyImageSharpFixed
                            }
                        }
                    }
                }
            }
        }
    }
`;